import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import { getConfigurationDetails } from "../../services/configuration/configuration.api";
import { type Config } from "../../types/configuration";
import { configurationActions } from "./slice";

// Worker Sagas
export function* onGetconfiguration(): SagaIterator {
  try {
    const countries: Config[] = yield call(getConfigurationDetails);
    yield put(configurationActions.fetchAllSucceeded(countries));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(configurationActions.fetchAllFailure(e.message.toString()));
    }
  }
}

// Watcher Saga
function* configurationWatcherSaga(): SagaIterator {
  yield takeEvery(configurationActions.fetchAll.type, onGetconfiguration);
}

export default configurationWatcherSaga;
